module.exports = __webpack_public_path__ + "media/lootbox_win_2.56cff790.mp3";